// extracted by mini-css-extract-plugin
export default {"jarvis":"newblog_jarvis__S6vkS","btn":"newblog_btn__txjsT"};